import React, { useState, useEffect, useRef } from "react";
import { Link } from "@tanstack/react-router";
import NavbarLast from '../../layouts/Head/NavbarLast'
import { useLocation } from '@tanstack/react-router'
import { handelTitle } from '../../utils'
import SecHeadSignup from './SecHeadSignup'
import SecForm from './SecForm'
import 'reactjs-popup/dist/index.css';
import { useI18n } from '../../i18n/context';

const SignUpContainer = () => {
  const { t } = useI18n();
  let location = useLocation();
  let type = location?.state?.type ? location.state.type : "email";

  let formStrings = {};
  formStrings.nameText = t('signUp.username');
  formStrings.emailText = type === "email" ? t('signUp.email') : t('signUp.recoveryEmail');
  formStrings.pwText = type === "email" ? t('signUp.password') : t('signUp.recoveryPassword');

  const [show, setShow] = useState(true);

  const callback = (vars_set) => {
    setShow(true);
  };

  useEffect(() => {
    handelTitle(t('signUp.title'));
  }, []);

  return (
    <>
      <NavbarLast/>
      <section className="h-100-vh mb-8">
        <SecHeadSignup />

        <div className="container">
          <div className="mt-n10" >
            <SecForm callback={callback} formStrings={formStrings} type={type} />
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUpContainer;
